import axios from 'axios'

export default {
  namespaced: true,

  actions: {
    getDoors({
      commit,
      rootGetters
    }) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/Doors/web/getbybranch?id=" + rootGetters.getBranch.id,
          method: "GET"
        }).then(response => {
          commit("updateDoors", {
            doors: response.data.entity
          }, {
            root: true
          });
          resolve(response);
        }).catch(error => {
          reject(error);
        })
      })
    },
    createDoor({
      commit
    }, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/Doors/web/create",
          data: obj,
          method: "POST"
        }).then(response => {
          if (response.data[0].status) {
            commit("addDoor", {
              door: response.data[0].entity
            }, {
              root: true
            })
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    createDoorOB({
      commit
    }, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/Doors/web/create",
          data: obj,
          method: "POST"
        }).then(response => {
          if (response.data[0].status) {
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    updateDoor({
      commit
    }, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/Doors/web/update",
          data: obj,
          method: "PUT"
        }).then(response => {
          if (response.data[0].status) {
            commit("updateDoor", {
              door: response.data[0].entity
            }, {
              root: true
            })
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          commit("throwError", {
            code: error.code,
            message: error.message
          }, {
            root: true
          })
          reject(error)
        })
      })
    },
    toggleDoor({
      commit
    }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/Doors/web/toggle?id=" + id,
          method: "PUT"
        }).then(response => {
          if (response.data.status) {
            commit("deleteDoor", {
              door: response.data.entity
            }, {
              root: true
            })
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    getDoorsByLevel(o, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/Doors/web/getbylevel?id=" + id,
          method: "GET"
        }).then(response => {
          if (response.data.status) {
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    updateDoorsLevel(o, payload) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/Doors/web/adddoorstolevel?id=" + payload.id,
          data: payload.data,
          method: "PUT"
        }).then(response => {
          if (response.data.status) {
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}